import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetMasterOrderEmailDraftQueryVariables = Types.Exact<{
  masterOrderId: Types.Scalars['String']['input'];
}>;


export type GetMasterOrderEmailDraftQuery = { __typename?: 'Query', masterOrderEmailDraft?: { __typename?: 'OrderInvoiceEmailDraftData', recipients: Array<string>, emailSubject: string, emailBody: string, reportId?: string | null, docType: Types.OrderEmailDocType, sender: { __typename?: 'TenantEmailSenderData', senderId: string, email: string, displayName: string, isDefault: boolean, isPlatformDefault: boolean } } | null };


export const GetMasterOrderEmailDraftDocument = new TypedDocumentString(`
    query GetMasterOrderEmailDraft($masterOrderId: String!) {
  masterOrderEmailDraft(masterOrderId: $masterOrderId) {
    recipients
    emailSubject
    emailBody
    reportId
    docType
    sender {
      senderId
      email
      displayName
      isDefault
      isPlatformDefault
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetMasterOrderEmailDraft: build.query<GetMasterOrderEmailDraftQuery, GetMasterOrderEmailDraftQueryVariables>({
      query: (variables) => ({ document: GetMasterOrderEmailDraftDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetMasterOrderEmailDraftQuery, useLazyGetMasterOrderEmailDraftQuery } = injectedRtkApi;
